import React__default from 'react';
import { useCLEcommContext } from '../../context/CLEcommContext.js';
import { CLPrescriptionSelectorContainer } from '../CLPrescriptionSelector/CLPrescriptionSelectorContainer.js';

/** @deprecated */ const ContactLensesSinglePurchase = ()=>{
    const { sortedAttributesSet  } = useCLEcommContext();
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "contact-lenses-single-purchase"
    }, /*#__PURE__*/ React__default.createElement(CLPrescriptionSelectorContainer, {
        prescriptionAttributesSet: sortedAttributesSet
    }));
};

export { ContactLensesSinglePurchase };
//# sourceMappingURL=ContactLensesSinglePurchase.js.map
